import sdk from '../../../sdk';
import Logger from '../../../services/Logger';
import localization from '../../../shared/strings';
import * as utils from '../../../shared/utils';
import Toast from '../../../components/Toast';
import TYPES from '../../action-types';
import { showDialog } from '../../../components/dialog';

/**
 * Unpublish from cdn
 * if id is provided, unpublish only one asset from preview to cdn
 */
const unPublishFromCdn = (id) => async (dispatch, getAll) => {
  const selectedAssets = id ? [id] : getAll().assets.selectedItems;
  const { selectedAssetsAggregatedData } = getAll().assets;

  try {
    dispatch({ type: TYPES.ASSETS.CDN.UNPUBLISH.START });
    Toast(localization.TOAST.UNPUBLISH_CDN_START(selectedAssets.length));
    const { data } = await sdk.assets.unpublishFromCdn({ ids: [...selectedAssets] });
    Logger.log('User', 'InfoPanelUnpublishFromCDN', {
      assets_number: data.unpublishedAssets?.length || 0,
    });

    const unpublishedCount = data.unpublishedAssets?.length || 0;
    const failedCount = data.failedAssets?.length || 0;
    const totalCount = selectedAssets.length;

    if (data.failedAssets && data.failedAssets.length > 0) {
      if (totalCount === 1 && failedCount === 1) {
        const errorMessage = localization.TOAST.UNPUBLISH_CDN_ERROR;
        Toast(errorMessage, { type: 'error' });
      } else {
        // Multiple assets with partial success - some assets unpublished, some failed
        Toast(localization.TOAST.UNPUBLISH_CDN_PARTIAL_SUCCESS(failedCount, totalCount), { type: 'error' });
      }
      dispatch({ type: TYPES.ASSETS.CDN.UNPUBLISH.FAILED, error: data.failedAssets[0].error });
    } else {
      // All assets unpublished successfully
      Toast(localization.TOAST.UNPUBLISH_CDN_SUCCESS(selectedAssets.length), { type: 'success' });
      dispatch({
        type: TYPES.ASSETS.CDN.UNPUBLISH.COMPLETE,
        payload: {
          assetIds: selectedAssets,
          data: data.unpublishedAssets || [],
          aggregatedData: { ...selectedAssetsAggregatedData, selectedAssetsWithCdnLinks: selectedAssetsAggregatedData.selectedAssetsWithCdnLinks - unpublishedCount },
        },
      });
    }
  } catch (error) {
    const errorStatus = utils.getStatusFromResponceError(error);
    const { BULK_CDN_PUBLISH_LIMIT } = localization.DIALOGS;

    if (errorStatus === 409) {
      showDialog({
        title: BULK_CDN_PUBLISH_LIMIT.title,
        text: BULK_CDN_PUBLISH_LIMIT.text,
        textBtnOk: BULK_CDN_PUBLISH_LIMIT.textBtnCancel,
        textBtnCancel: null,
        onOk: null,
      });
    } else if (errorStatus === 413) {
      // File size exceeds limit (though less likely for unpublishing)
      Toast(localization.TOAST.PUBLISH_CDN_SIZE_LIMIT, { type: 'error' });
    } else {
      Toast(localization.TOAST.UNPUBLISH_CDN_ERROR, { type: 'error' });
    }

    dispatch({ type: TYPES.ASSETS.CDN.UNPUBLISH.FAILED, error });
    Logger.error(new Error('Can not unpublish assets to cdn'), { error }, [
      'UnPublishToCdntFailed',
      { errorMessage: (error && error.message) || 'NoMessage' },
    ]);
  }
};
export default unPublishFromCdn;
